import React from 'react';
import {Button, ControlGroup, InputGroup} from '@blueprintjs/core';
import {IconNames} from '@blueprintjs/icons';
import {Popover2} from '@blueprintjs/popover2';

import {DEFAULT_TEXT_LIST, TextListItem} from '../constants';

interface TextListOptionsProps {
  options: TextListItem[];
  onChange: (value: TextListItem[]) => void;
}

interface AddOptionsProps {
  options: TextListItem[];
  onAdd: () => void;
  onChange: (key: string, index: number) => (value: any) => void;
  onRemove: (index: number) => void;
}

const AddOptions = ({
  options,
  onAdd,
  onChange,
  onRemove,
}: AddOptionsProps) => {
  const disableRemove = options.length === 1;

  return (
    <div className="add-options-popover">
      {
        options.map((option: TextListItem, index: number) => {
          return (
            <ControlGroup key={index}>
              <InputGroup placeholder="Value" value={option.value} onChange={onChange('value', index)}/>
              <InputGroup placeholder="Name" value={option.name} onChange={onChange('name', index)}/>
              <Button
                icon={IconNames.CROSS}
                minimal={true}
                onClick={() => onRemove(index)}
                disabled={disableRemove}
              />
            </ControlGroup>
          )
        })
      }
      <Button
        text="Add"
        icon={IconNames.PLUS}
        onClick={onAdd}
      />
    </div>
  )
}

export const TextListOptions = ({
  options,
  onChange,
}: TextListOptionsProps) => {
  const onAdd = () => {
    onChange([
      ...options,
      ...DEFAULT_TEXT_LIST,
    ]);
  };

  const onRemove = (rowIndex: number) => {
    if (options.length > 1) {
      onChange([
        ...options.slice(0, rowIndex),
        ...options.slice(rowIndex + 1),
      ]);
    }
  };

  const onRowChange = (key: string, rowIndex: number) => (event: any) => {
    const newValue = event.target.value;

    const newOptions: TextListItem[] = options.map((option: TextListItem, index: number) => {
      if (rowIndex === index) {
        return {...option, [key]: newValue};
      }
      return {...option};
    });

    onChange(newOptions)
  };

  return (
    <Popover2
      content={
        <AddOptions
          options={options}
          onAdd={onAdd}
          onChange={onRowChange}
          onRemove={onRemove}
        />
      }
    >
      <Button
        className="add-options"
        icon={IconNames.PLUS}
        minimal={true}
      />
    </Popover2>
  )
};
